export enum TitleType {
  NORMAL = 'normal',
  SLASH = 'slash',
  LINE = 'line',
}
